import { isValidIconElement, Slot } from '@farol-ds/react'
import classNames from 'classnames'
import { cloneElement, HTMLAttributes } from 'react'

import styles from './list-block.module.scss'

export type ListBlockLeadingElement = HTMLSpanElement

export type ListBlockLeadingProps = HTMLAttributes<ListBlockLeadingElement> & {
  asChild?: boolean
}

function ListBlockLeading(props: ListBlockLeadingProps) {
  const { children, className, asChild, ...rest } = props
  const classes = classNames(styles.leading, className)

  const Component = asChild ? Slot : 'span'

  return (
    <Component className={classes} {...rest}>
      {isValidIconElement(children) ? cloneElement(children, { size: 'sm' }) : children}
    </Component>
  )
}

export default ListBlockLeading
